import React from "react";
import { FormattedNumber } from "react-intl";

export default function RoundedNumber(props) {
  const value = props.amount || props.value;

  if (!value) {
    return null;
  }
  return (
    <FormattedNumber
      value={props.number || props.value}
      useGrouping={false}
      minimumFractionDigits={0}
      maximumFractionDigits={0}
    />
  );
}
